// extracted by mini-css-extract-plugin
module.exports = {"smooth":"_view_smooth__nSz33"};